import React from 'react'
import { Sticky } from 'react-bootstrap-icons'
import HoverTooltip from '../HoverTooltip'

export default function AssetListItemNoteIcon({ note, className = '' }) {
  const preview = typeof note === 'string' ? note.trim() : ''
  if (!preview) return null

  return (
    <HoverTooltip content={preview} stopPropagation>
      <Sticky aria-label="Asset note" className={className} />
    </HoverTooltip>
  )
}
